<!-- This is the ui-form-label wrapper; consumers provide the input via projection. -->
<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
<label
  class="d-flex gap-1 align-items-center form-label"
  [ngClass]="{
    required: requiredLabel,
  }"
  [class]="class()"
>
  <ng-content></ng-content>
  @if (tooltip()) {
    <ui-keenicon
      [tooltip]="tooltip()"
      name="information"
      class="fs-3 cursor-pointer"
    ></ui-keenicon>
  }
</label>
